export default "__VITE_ASSET__C6iH5GIS__"